module.exports = __webpack_public_path__ + "needumomtext2.svg?a263fe19f916039580f97d7f2e49cd38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/needumomtext2.svg
// module id = 151
// module chunks = 0